import { RadioButton as RadioButtonComponent } from './RadioButton';
import { RadioGroup } from './RadioGroup';

export const Radio = Object.assign(
  // 메인 네임스페이스 (사용하지 않지만 Radio.Button, Radio.Group을 위한 컨테이너)
  RadioButtonComponent,
  {
    Group: RadioGroup,
  },
);

export type { RadioButtonProps as RadioProps } from './RadioButton';
export type { RadioGroupProps } from './RadioGroup';
